<section class="container">
  <app-faq-section [title]="block().title" [group]="faqArray$()" [cookiePreferences]="cookiePreferences() || undefined"></app-faq-section>
</section>
